window.get_locale = function get_locale() {
    var locale = 'it';
    var available_locales = ['it', 'en', 'fr', 'de', 'es'];
    var window_locale = navigator.language || navigator.userLanguage;
    window_locale = window_locale.substring(0, 2).toLowerCase();
    if (available_locales.includes(window_locale)) {
        locale = window_locale;
    }
    return locale;
}